export default __webpack_public_path__ + "images/7ae5d104bcf45af472f2a78a1c1a5732.svg";